/**
 * Debounce from underscore.js (with some changes)
 * @param {Function} fn - function to call
 * @param {int} ms - millisecond after the fn must be called if the event isn't triggered
 * @param {string} uniqueId - unique id to register more then one debounced event
 * @param {boolean} immediate - if this param is true the function is called at first event and the event will be ignored if the function is called before the ms amount
 * @return {undefined}
 */
function waitForFinalEvent(fn, ms, uniqueId, immediate = false) {
	const timers = {};
	return function checkEvent() {
		const later = () => {
			timers.uniqueId = null;
			if (!immediate) fn();
		};
		const callNow = immediate && !timers.uniqueId;
		clearTimeout(timers.uniqueId);
		timers.uniqueId = setTimeout(later, ms);
		if (callNow) fn();
	};
}

module.exports = waitForFinalEvent;



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/waitForFinalEvent.js
 **/